import axios from 'axios'
import {
  ECommerceLead,
  ECommerceLeadComment,
  ECommerceLeadCommentsResponse,
  ECommerceLeadsParams,
} from '../models/e-commerce'
import {LaravelPaginationModel} from '../models/LaravelPaginationModel'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}`

export async function getECommerceLeads(params: ECommerceLeadsParams) {
  return await axios.get<LaravelPaginationModel<ECommerceLead>>(`${API}/leads`, {params})
}

export async function getECommerceLead(id: number) {
  return await axios.get<ECommerceLead | {data: ECommerceLead}>(`${API}/leads/${id}`)
}

export async function getECommerceLeadComments(leadId: number, page = 1) {
  return await axios.get<ECommerceLeadCommentsResponse>(`${API}/leads/${leadId}/comments`, {
    params: {page},
  })
}

export async function createECommerceLeadComment(leadId: number, comment: string) {
  return await axios.post<{data: ECommerceLeadComment}>(
    `${API}/leads/${leadId}/comments`,
    {comment},
    {headers: {'Content-Type': 'application/json'}}
  )
}

export async function saveECommerceLead(data: Partial<ECommerceLead>) {
  return await axios.post(`${API}/leads`, data, {headers: {'Content-Type': 'application/json'}})
}

export async function updateECommerceLead(id: number, data: Partial<ECommerceLead>) {
  return await axios.post(`${API}/leads/${id}?_method=PATCH`, data, {
    headers: {'Content-Type': 'application/json'},
  })
}

export async function deleteECommerceLead(id: number) {
  return await axios.delete(`${API}/leads/${id}`)
}
